interface DifferentialCardProps {
  icon: string;
  title: string;
  description: string;
}

export default function DifferentialCard({ icon, title, description }: DifferentialCardProps) {
  return (
    <div className="text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/50 hover:border-primary-200/30 transition-all duration-300 cursor-default group">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
        <i className={`${icon} text-2xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-900 font-heading mb-1.5">
        {title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed max-w-[220px] mx-auto">
        {description}
      </p>
    </div>
  );
}